import React from 'react';
import { GuestTravelMapComponentFragment } from '@graphql/generated';
import { useFeatureValue } from '@shared/core/featureFlags';
import { Accommodations as AccommodationsV1 } from './Accommodations';
import { AccommodationsV2 } from './AccommodationsV2';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

interface AccommodationsProps {
  pageId: string;
  eventId: string;
  pageSlug: string;
  eventHandle: string;
  pageTitle?: string;
  subTitle?: string | null;
  isBrannanLayout?: boolean;
  travelMapComponentData: GuestTravelMapComponentFragment;
}

export const Accommodations: React.FC<AccommodationsProps> = props => {
  const { value, loading } = useFeatureValue('accommodationsGuestV2Enabled');
  const accommodationsGuestV2Enabled = value === 'on';
  if (loading) {
    return <JoyLogoLoader loaderKey="accommodations-guest-v2" />;
  }
  return accommodationsGuestV2Enabled ? <AccommodationsV2 {...props} /> : <AccommodationsV1 {...props} />;
};

// Keep TravelMap export for backward compatibility during migration
export const TravelMap = Accommodations;
